export default theme => ({
  root: {
    overflow: 'auto'
  },
  tableCell: {
    whiteSpace: 'nowrap'
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center'
  },
  paper: {
    padding: theme.spacing(1),
  },
  tableButton: {
    padding: 0,
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
  warningButton: {
    color: theme.palette.warning.main
  }
});

